import { useQuery } from '@tanstack/react-query';
import { timeRangeToQueryWindow } from '../mapping';

export interface QueryWindow { start: number; end: number; step: number }

// Shared panel data-fetch discipline. The time WINDOW (which contains
// Date.now()) is computed INSIDE queryFn, never in the queryKey — putting it
// in the key would change the key every render and spin an infinite refetch
// loop. Every historical panel (chart/stat/gauge/faults) MUST fetch through
// this hook so that invariant lives in exactly one place.
export function usePanelQuery<T>(
  keyParts: ReadonlyArray<unknown>,
  timeRange: string,
  refreshMs: number,
  fetcher: (window: QueryWindow) => Promise<T>,
) {
  return useQuery({
    queryKey: [...keyParts, timeRange],
    queryFn: () => fetcher(timeRangeToQueryWindow(timeRange)),
    refetchInterval: refreshMs > 0 ? refreshMs : false,
  });
}
